import { hotTopics } from '@/mocks/blackinfo';

export default function HotRank() {
  return (
    <section id="hot" className="mx-auto max-w-[1280px] px-4 pt-12 md:px-6 md:pt-16">
      <div className="rounded-lg border border-stone-200 bg-white">
        <div className="flex items-center justify-between border-b border-stone-100 px-5 py-4 md:px-6">
          <h2 className="flex items-center gap-2 font-display text-lg font-bold text-stone-950 md:text-xl">
            <i className="ri-fire-fill text-red-600" /> 热门话题榜
          </h2>
          <span className="inline-flex items-center gap-1 text-[11px] text-stone-400 sm:text-xs">
            <i className="ri-refresh-line" /> 实时热度 12 分钟前更新
          </span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {hotTopics.map((t) => (
            <a
              key={t.rank}
              href="#today"
              className="group flex items-center gap-4 border-b border-stone-100 px-5 py-4 transition-colors hover:bg-stone-50 md:px-6"
            >
              <span
                className={
                  'w-7 shrink-0 text-center font-display text-xl font-black ' +
                  (t.rank === 1 ? 'text-red-600' : t.rank === 2 ? 'text-amber-500' : t.rank === 3 ? 'text-amber-400' : 'text-stone-300')
                }
              >
                {String(t.rank).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-stone-900 group-hover:text-red-700 md:text-base">
                  {t.title}
                </h3>
                <p className="mt-0.5 text-xs text-stone-400">{t.heat}</p>
              </div>
              <span
                className={
                  'shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ' +
                  (t.delta.startsWith('新') ? 'bg-red-50 text-red-600' : t.delta.startsWith('↓') ? 'bg-stone-100 text-stone-500' : 'bg-amber-50 text-amber-600')
                }
              >
                {t.delta}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}